// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
    New: 1,
    Emailed: 2,
    PartiallyPaid: 3,
    Paid: 4,
    Complete: 5,
    Credit: 6,
};
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
}

